import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  FaGlobe,
  FaLaptopCode,
  FaShieldAlt,
  FaThumbsUp,
  FaUniversalAccess,
  FaLightbulb,
  FaChartLine,
  FaAward,
} from "react-icons/fa";

/* Ordem casa com whyChooseUs.items nos locales. */
const ICONS = [
  FaGlobe,
  FaLaptopCode,
  FaShieldAlt,
  FaThumbsUp,
  FaUniversalAccess,
  FaLightbulb,
  FaChartLine,
  FaAward,
];

const MAX_STAGGER_STEPS = 5;

export const WhyChooseUs = () => {
  const { t, i18n } = useTranslation("landing");
  const sectionRef = useRef(null);
  const items = t("whyChooseUs.items", { returnObjects: true });
  const count = Array.isArray(items) ? items.length : 0;

  useEffect(() => {
    const section = sectionRef.current;
    if (!section || !count) return;

    const targets = Array.from(section.querySelectorAll(".js-why-reveal"));
    if (!targets.length) return;

    if (
      !("IntersectionObserver" in window) ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }

    // Só escondemos depois de confirmar que o JS roda e vai revelar.
    section.classList.add("js-reveal");

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries
          .filter((entry) => entry.isIntersecting)
          .forEach((entry, indexInBatch) => {
            entry.target.style.setProperty(
              "--i",
              Math.min(indexInBatch, MAX_STAGGER_STEPS)
            );
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );

    targets.forEach((el) => observer.observe(el));
    return () => {
      observer.disconnect();
      section.classList.remove("js-reveal");
    };
  }, [count, i18n.language]);

  if (!count) return null;

  return (
    <section className="why-choose-us" ref={sectionRef}>
      <h2 className="why-choose-us__title js-why-reveal">
        {t("whyChooseUs.title")}{" "}
        <span className="why-choose-us__title-accent">
          {t("whyChooseUs.titleHighlight")}
        </span>
      </h2>

      <div className="why-cards-container">
        {items.map((title, index) => {
          const Icon = ICONS[index] || FaGlobe;
          return (
            <article key={index} className="why-card js-why-reveal">
              <span className="why-icon">
                <Icon />
              </span>
              <p className="why-title">{title}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
};
